<template>
	<div>
		<label class="pre-text">{{pre_item.name}}:</label>
		<input type="text" class="pre-input" 
		    :class="swichClass(pre_item)" v-model="pre_item.val"
			:placeholder="pre_item.note" 
			:readonly="(pre_item.r=='1') ? 'readonly':false " 
			@keyup.enter="fun_add"
			@change="val_back" @click="fun_once" 
			@mouseenter="show_detaildata($event,pre_item.val)"
			@mouseleave="noshow_detaildata()" />
			
		<em class="pre-em" v-show="pre_item.w=='1'">*</em>
		<em class="pre-em" v-show="pre_item.w=='0'"></em>


	</div>
</template>

<script>
	//
	import {
		BackSpecial
	} from "@/utils/localstore.js";

	export default {
		name: "hj-text",
		data() {
			return {
				pre_item: {},
			}
		},
		props: {
			inData: {
				type: String,
				default: ''
			}
		},
		watch: {
			inData(val) {
				this.pre_item = {};
				this.pre_item = JSON.parse(BackSpecial(this.inData));
			}
		},
		created() {
			this.pre_item = {};
			this.pre_item = JSON.parse(BackSpecial(this.inData));
			// console.log(this.pre_item);
		},
		activated: function() {
			// console.log('keep-alive 组件激活时调用 hj-input激活');
			// console.log('激活',this.inData);
			this.pre_item = {};
			this.pre_item = JSON.parse(BackSpecial(this.inData));
		},
		deactivated: function() {
			// console.log('keep-alive 组件激活时调用 hj-input停用');
			this.pre_item = {};
		},
		methods: {
			swichClass: function(item) {
				// console.log(item);
				let temp_class = item.class;
				temp_class = String(temp_class).replace(' ', '')
				return {
					"long1": temp_class === "long1",
					"long1-2": temp_class === "long1-2",
					"long2": temp_class === "long2",
					"long3": temp_class === "long3",
					"long4": temp_class === "long4",
					"long5": temp_class === "long5",
					"input-readonly": item.r === "1"
				};
			},
			val_back: function() {
				// this.$emit('com-event', this.pre_item);
				this.fun_trim('');
			},
			fun_add: function() {
				// this.$emit('com-event', this.pre_item, 'save');
				this.fun_trim('save');
			},
			fun_once: function() {
				// this.$emit('com-event', this.pre_item, 'click');
				this.fun_trim('click');
			},
			fun_trim:function(type){
				// let str='';
				// str=this.pre_item.val;
				// str=String(str).trimStart();
				// str=String(str).trimEnd();
				// str=str.replace(/\t/g, '');
				// this.pre_item.val=str;
				
				let str = '';
				str = this.pre_item.val;
				
				let arrOld = str.split("");
				// 合法性校验，只允许是汉字字符常见符号
				// let reg = /^[0-9\u4e00-\u9fa5a-zA-Z\{\}\(\)\"\"\\'\'\/\/\[\]+\-\_\,\:\.\\\s+]+$/;
				// 汉字范围：\u4e00-\u9fa5
				// 字母范围：A-Za-z
				// 数字范围：0-9
				// \p{P}          - 匹配任何标点符号（Unicode属性）
				// \p{S}          - 匹配任何数学运算符（Unicode属性）
				// \s             - 匹配任何空白字符，包括空格、制表符、换页符等
				// 常用标点符号范围：！-～（这里包括了大部分常用标点符号，但不包括所有特殊符号，可根据需要调整）
				// 数学运算符：+-*/（这里只包括了基础的数学运算符）
				let reg = /^[A-Za-z0-9\u4e00-\u9fa5!-～+\-*\/\s]+$/;
				
				let arrOK = '';
				
				for (let i = 0; i < arrOld.length; i++) {
					if (reg.test(arrOld[i])) {
						arrOK = arrOK + arrOld[i];
					}
				}
				
				this.pre_item.val = arrOK;
				// console.log('字符检测' + arrOK);
				
				this.$emit('com-event', this.pre_item, type);
			},
			show_detaildata: function(that, item) {
				if (item == '') {
					return;
				}
				var x = 0,
					y = 0,
					temp_css = '';

				// console.log(that);
				x = that.clientX + 10;
				y = that.clientY;
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				temp_css = "display: block;position: fixed;;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";

				temp_css += "max-width: 1024px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

				let temp_innerHtml = '';

				temp_innerHtml = BackSpecial(item);
				if (temp_innerHtml.indexOf('^') > 0) {
					let arr = temp_innerHtml.split('^');
					let new_str = '';
					for (let i = 0; i < arr.length; i++) {
						new_str = new_str + arr[i] + "<br/>";
					}
					temp_innerHtml = new_str;
				} else {

					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>");
				}
				// console.log(temp_innerHtml);
				// pre_tan_msg 必须只能有一个哦
				document.getElementById("pre_tan_msg").innerHTML = temp_innerHtml;
				document.getElementById("pre_tan_msg").style.cssText = temp_css;

			},
			noshow_detaildata: function() {
				document.getElementById("pre_tan_msg").style.display = 'none';
			},
		}
	}
</script>

<style scoped="scoped">
	.pre-text {
		display: inline-block;
		vertical-align: middle;
		margin-right: 2px;
		min-width: 108px;
	}

	.pre-input {
		display: inline-block;
		vertical-align: middle;
		width: 128px;
	}

	.pre-em {
		display: inline-block;
		vertical-align: middle;
		width: 10px;
	}

	.input-readonly {
		background-color: rgb(243, 243, 243);

	}
	
	.long1-2{
		  width: 168px;
	}
</style>
